<div class="container-fluid p-0">
  <div class="row">
    <div class="col-12">
      <div class="login-card">
        <div>
          <div>
            <a class="logo" routerLink="/"><h2>Hotel</h2></a>
          </div>
          <div class="login-main">
            <form class="theme-form" [formGroup]="loginForm">
              <h4>Anmelden</h4>
              <p>E-Mail und Passwort eingeben</p>
              <div class="form-group">
                <label class="col-form-label">E-Mail-Adresse</label>
                <input class="form-control" type="email" required="" placeholder="app@yourmail.com" formControlName="email" />
                <div *ngIf="loginForm.controls.email.touched && loginForm.controls.email.errors?.required" class="text text-danger mt-1">E-Mail ist erforderlich</div>
                <div *ngIf="loginForm.controls.email.touched && loginForm.controls.email.errors?.email" class="text text-danger mt-1">Ungültige E-Mail</div>
              </div>
              <div class="form-group">
                <label class="col-form-label">Passwort</label>
                <input class="form-control" [type]="show ? 'text' : 'password'" formControlName="password" required="" placeholder="*********" />
                <div class="show-hide" (click)="showPassword()" *ngIf="!show"><span class="show"></span></div>
                <div class="show-hide" (click)="showPassword()" *ngIf="show"><span class="Hide"></span></div>
                <div *ngIf="loginForm.controls.password.touched && loginForm.controls.password.errors?.required" class="text text-danger mt-1">Passwort wird benötigt</div>
              </div>
              <div class="form-group mb-0">
                <!-- <a [routerLink]="'/authentication/forgot-password'" class="link">Passwort vergessen?</a> -->
                <div class="text-end mt-3">
                  <button class="btn btn-primary d-block w-100" [disabled]="!loginForm.valid" (click)="login()" type="button"><span>Login</span></button>
                </div>
              </div>
              <p class="mt-4 mb-0">
                Sie haben kein Account?
                <a [routerLink]="'/auth/registration'" class="ms-2">Account erstellen</a>
              </p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
